
import {
  URL_LOGO_TYPE,
  GCLOUD_LOGO_TYPE,
  SCHEDULE_TYPE_ASAP,
  SCHEDULE_TYPE_SCHEDULED,
  ACCESS_CODE_LOGIN_TYPE,
  CLUB_MED_LOGIN_TYPE,
  EMAIL_LOGIN_TYPE,
  SIZED_PRINT_MODE,
  MULTI_PRINT_MODE,
  LEGACY_PRINT_MODE,
  DEFAULT_PAGE_MODE,
  CLUBMDED_PAGE_MODE,
  HAWKS_PAGE_MODE,
  EMAIL_PAGE_MODE
} from 'shared/utils/Constants';

import {
  getCurrencySign
} from 'shared/services/PriceService';

export const formatError = error => {
  if (typeof error === 'string') {
    return error;
  }
  return error.error || error.message || JSON.stringify(error);
}

export const formatJobConfigCellValue = value => {
  try {
    //const jobConfigId = value;
    //let jobConfig = jobConfigs.find(jc => jc.id === value);
    let jobConfig = value;

    return jobConfig ? jobConfig.name : '';
  } catch (err) {
    console.error(err);
    return '';
  }
}

export const formatJobSelectLabel = job => {
  return <span>{job.name} - <i>{job.event_id}</i></span>;
}

export const formatJobOptionLabel = job => {
  return `${job.name} - ${job.event_id}`;
}

export const formatJobCellValue = value => {
  try {
    let job = value;
    return formatJobSelectLabel(job);
  } catch (err) {
    console.error(err);
    return '';
  }
}

export const formatCustomerSelectLabel = customers => {
  if (!Array.isArray(customers)) {
    customers = [customers];
  }

  return customers
    .map(customer => {
      return customer.name || customer.email || customer.phone || customer.access_code;
    })
    .join(', ');
}

export const formatCustomersCellValue = (customers, value) => {
  // the value being passed to the valueFormatter callback is an object?
  // this is only happening with this colDef
  if (typeof value === 'object' && value !== null) {
    value = value.value;
  }

  if (!value) {
    return '';
  }

  // value is customer IDs separated by hyphens, with leading and trailing hyphens.
  // ex: -123-234-456-
  const customerIdsStr = value;
  let customerIds = customerIdsStr.split('-');
  let momentCustomers = [];

  for (let customerId of customerIds) {
    let customer = customers.find(c => c.id == customerId);
    if (customer) {
      momentCustomers.push(customer);
    }
  }

  return formatCustomerSelectLabel(momentCustomers);
}

export const formatKioskCellValue = value => {
  try {
    let kiosk = value;

    return kiosk ? kiosk.name : '';
  } catch (err) {
    console.error(err);
    return '';
  }
}

export const formatKioskPrintModeCellValue = value => {
  switch (value) {
    case SIZED_PRINT_MODE:
      return 'SIZED PRINT MODE';
    case MULTI_PRINT_MODE:
      return 'MULTI PRINT MODE';
    case LEGACY_PRINT_MODE:
      return 'LEGACY PRINT MODE';
    default:
      return 'DISABLED PRINT MODE';
  }
}

export const formatKioskThemeCellValue = value => {
  switch (value) {
    case 'legacy':
      return 'LEGACY';
    case 'clubmed':
      return 'CLUBMED';
    case 'hpx':
      return 'HPX';
    case 'icecstl':
      return 'ICE CASTLE';
  }
}

export const formatCheckoutTypeCellValue = (value) => {
  return value === 0 ? 'HAGGLE MODE' : 'MARKETPLACE';
}

export const formatKioskLoginTypeCellValue = (value) => {
  switch (value) {
    case ACCESS_CODE_LOGIN_TYPE:
      return 'ACCESS CODE';
    case CLUB_MED_LOGIN_TYPE:
      return 'CLUBMED';
    case EMAIL_LOGIN_TYPE:
      return 'EMAIL ADDRESS'
  }
}

export const formatPageModeCellValue = (value) => {
  switch (value) {
    case DEFAULT_PAGE_MODE:
      return 'DEFAULT';
    case CLUBMDED_PAGE_MODE:
      return 'CLUBMED';
    case HAWKS_PAGE_MODE:
      return 'HAWKS';
    case EMAIL_PAGE_MODE:
      return 'EMAIL ADDRESS'
  }
}

export const formatPascalCase = (text) => {
  const titleCase = text.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
  return titleCase;
}

export const formatCurrency = (amount, currency) => {
  currency ||= 'USD';
  let symbol = getCurrencySign(currency);
  let text = `${symbol}${amount ?? '0.00'} ${currency}`;

  return text;
}

export const formatEllipsis = (value, maxLength) => {
  if (value && value.length > maxLength) {
    return value.substr(0, maxLength) + '...';
  } else {
    return value;
  }
}

export const downloadTypeOptions = () => {
  return [
    { label: 'Cards', labelStr: 'Cards', value: 0 },
    { label: 'Pages', labelStr: 'Pages', value: 1 }
  ]
}

export const objectsAreSame = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr2.length; i++) {
    if (arr1[i] && arr2[0]) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
}
